// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-container.customDropdown {
    position: relative;
    width: 100%;
    margin-bottom: 1rem;
}

.customDropdown .multi-select-label {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #333;
}

/* Added text-danger class for required asterisk */
.customDropdown .text-danger {
    color: #dc3545;
}

.customDropdown .multi-select-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* min-height: 38px;
    padding: 6px 12px; */
    height: 45px;          
    padding: 0 12px;
    border: 1px solid #dee2e6;  
    border-radius: 6px;
    background-color: white;
    cursor: pointer;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.customDropdown .multi-select-input:hover {
    border-color: #86b7fe;
}

.customDropdown .multi-select-input.open {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}

.customDropdown .multi-select-input.disabled {
    background-color: #e9ecef;
    cursor: not-allowed;
    opacity: 0.75;
}

.customDropdown .multi-select-input.disabled:hover {
    border-color: #dee2e6;
}

.customDropdown .selected-items {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    flex: 1 1;
    align-items: center;
    min-width: 0;
}

.customDropdown .placeholder {
    color: #838FB4;
    font-size: 14px;
    background: none;
    opacity: 1;
}

/* Updated badge classes to work without Bootstrap components */
.customDropdown .badge-primary {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background-color: #0d6efd;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
}

.customDropdown .badge-secondary {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background-color: #6c757d;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
}

.customDropdown .selected-item {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background-color: rgba(0, 102, 204, 0.15) !important;
    color: #0066CC !important;
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
    max-width: 100%;
    min-width: 0;
}

.customDropdown .selected-item-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.customDropdown .more-items {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    background: none !important;   
    color: #7D7D7D !important; 
    border-radius: 4px;
    font-size: 12px;
    font-weight: normal;
}

.customDropdown .remove-btn {
    background: none;
    border: none;
    color: inherit;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    transition: background-color 0.15s ease;
}

/* Cross button inside "+more" */
.customDropdown .more-items .remove-btn {
    color: #EC6157 !important;     /* red cross */
}

.customDropdown .remove-btn:hover {
    /* background-color: rgba(255, 255, 255, 0.2); */
    background-color: rgba(236, 97, 87, 0.1);
}

.customDropdown .remove-btn:disabled {
    cursor: not-allowed;
}

.customDropdown .dropdown-arrow {
    color: #6c757d;
    transition: transform 0.15s ease;
    flex-shrink: 0;
    margin-left: 8px;
}

.customDropdown .dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.customDropdown .dropdown-menu-custom {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: white;
    border: 1px solid #ced4da;
    border-radius: 6px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    max-height: 200px;
    overflow-y: auto;
    margin-top: 2px;
}

.customDropdown .dropdown-item-custom {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.customDropdown .dropdown-item-custom:hover {
    background-color: #f8f9fa;
}

.customDropdown .dropdown-item-custom.selected {
    background-color: #e7f3ff;
}

/* Added custom checkbox styling to replace Bootstrap form components */
.customDropdown .checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    margin: 0;
    width: 100%;
}

.customDropdown .checkbox-input {
    margin-right: 8px;
    cursor: pointer;
}

.customDropdown .checkbox-text {
    cursor: pointer;
    flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/MultiSelect/MultiSelectDropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;wBACoB;IACpB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,wEAAwE;AAC5E;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAO;IACP,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA,+DAA+D;AAC/D;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oDAAoD;IACpD,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA,gCAAgC;AAChC;IACI,yBAAyB,MAAM,cAAc;AACjD;;AAEA;IACI,gDAAgD;IAChD,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,6CAA6C;IAC7C,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,SAAO;AACX","sourcesContent":[".multi-select-container.customDropdown {\n    position: relative;\n    width: 100%;\n    margin-bottom: 1rem;\n}\n\n.customDropdown .multi-select-label {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    color: #333;\n}\n\n/* Added text-danger class for required asterisk */\n.customDropdown .text-danger {\n    color: #dc3545;\n}\n\n.customDropdown .multi-select-input {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* min-height: 38px;\n    padding: 6px 12px; */\n    height: 45px;          \n    padding: 0 12px;\n    border: 1px solid #dee2e6;  \n    border-radius: 6px;\n    background-color: white;\n    cursor: pointer;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.customDropdown .multi-select-input:hover {\n    border-color: #86b7fe;\n}\n\n.customDropdown .multi-select-input.open {\n    border-color: #86b7fe;\n    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n}\n\n.customDropdown .multi-select-input.disabled {\n    background-color: #e9ecef;\n    cursor: not-allowed;\n    opacity: 0.75;\n}\n\n.customDropdown .multi-select-input.disabled:hover {\n    border-color: #dee2e6;\n}\n\n.customDropdown .selected-items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    flex: 1;\n    align-items: center;\n    min-width: 0;\n}\n\n.customDropdown .placeholder {\n    color: #838FB4;\n    font-size: 14px;\n    background: none;\n    opacity: 1;\n}\n\n/* Updated badge classes to work without Bootstrap components */\n.customDropdown .badge-primary {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    background-color: #0d6efd;\n    color: white;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.customDropdown .badge-secondary {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    background-color: #6c757d;\n    color: white;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.customDropdown .selected-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    background-color: rgba(0, 102, 204, 0.15) !important;\n    color: #0066CC !important;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: normal;\n    max-width: 100%;\n    min-width: 0;\n}\n\n.customDropdown .selected-item-text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.customDropdown .more-items {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 8px;\n    background: none !important;   \n    color: #7D7D7D !important; \n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.customDropdown .remove-btn {\n    background: none;\n    border: none;\n    color: inherit;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    transition: background-color 0.15s ease;\n}\n\n/* Cross button inside \"+more\" */\n.customDropdown .more-items .remove-btn {\n    color: #EC6157 !important;     /* red cross */\n}\n\n.customDropdown .remove-btn:hover {\n    /* background-color: rgba(255, 255, 255, 0.2); */\n    background-color: rgba(236, 97, 87, 0.1);\n}\n\n.customDropdown .remove-btn:disabled {\n    cursor: not-allowed;\n}\n\n.customDropdown .dropdown-arrow {\n    color: #6c757d;\n    transition: transform 0.15s ease;\n    flex-shrink: 0;\n    margin-left: 8px;\n}\n\n.customDropdown .dropdown-arrow.rotated {\n    transform: rotate(180deg);\n}\n\n.customDropdown .dropdown-menu-custom {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: white;\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n    max-height: 200px;\n    overflow-y: auto;\n    margin-top: 2px;\n}\n\n.customDropdown .dropdown-item-custom {\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n.customDropdown .dropdown-item-custom:hover {\n    background-color: #f8f9fa;\n}\n\n.customDropdown .dropdown-item-custom.selected {\n    background-color: #e7f3ff;\n}\n\n/* Added custom checkbox styling to replace Bootstrap form components */\n.customDropdown .checkbox-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-size: 14px;\n    margin: 0;\n    width: 100%;\n}\n\n.customDropdown .checkbox-input {\n    margin-right: 8px;\n    cursor: pointer;\n}\n\n.customDropdown .checkbox-text {\n    cursor: pointer;\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
